"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MPShop
 * API documentation
 *
 * The version of the OpenAPI document: 0.0.1-alpha.58
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTypeToJSON = exports.ProductTypeFromJSONTyped = exports.ProductTypeFromJSON = exports.ProductType = void 0;
/**
 *
 * @export
 */
exports.ProductType = {
    Insurance: 'INSURANCE',
    Taxi: 'TAXI',
    Flight: 'FLIGHT',
    Accommodation: 'ACCOMMODATION'
};
function ProductTypeFromJSON(json) {
    return ProductTypeFromJSONTyped(json, false);
}
exports.ProductTypeFromJSON = ProductTypeFromJSON;
function ProductTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ProductTypeFromJSONTyped = ProductTypeFromJSONTyped;
function ProductTypeToJSON(value) {
    return value;
}
exports.ProductTypeToJSON = ProductTypeToJSON;
